<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div :class="{ 'fixed-header': fixedHeader }">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
    </div>

    <!-- 未确认通知对话框 -->
    <notify-dialog
      v-if="unconfirmedDialogVisible"
      :visible.sync="unconfirmedDialogVisible"
      :notify-list="unconfirmedNotifyList"
      :current-index.sync="currentNotifyIndex"
      @confirmed="handleNotifyConfirmed" />
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";
import NotifyDialog from "@/components/NotifyDialog";
import { getUnconfirmedNotifies } from "@/api/notify";
import { groupUnconfirmedNotifies } from "@/utils/notify-group";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
    NotifyDialog,
  },
  mixins: [ResizeMixin],
  data() {
    return {
      unconfirmedDialogVisible: false,
      unconfirmedNotifyList: [],
      currentNotifyIndex: 0
    }
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  mounted() {
    this.checkUnconfirmedNotifications()
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    },
    async checkUnconfirmedNotifications() {
      try {
        const { data } = await getUnconfirmedNotifies()
        const grouped = groupUnconfirmedNotifies(data)
        if (grouped.length > 0) {
          this.unconfirmedNotifyList = grouped
          this.currentNotifyIndex = 0
          this.unconfirmedDialogVisible = true
        }
      } catch (error) {
        console.error('检查未确认通知失败:', error)
      }
    },
    handleNotifyConfirmed(notifyId) {
      // 从列表中移除已确认的通知
      const index = this.unconfirmedNotifyList.findIndex(n => n.id === notifyId)
      if (index > -1) {
        this.unconfirmedNotifyList.splice(index, 1)
        // 如果当前索引指向被删除的项或之后的项，需要调整索引
        // 由于后面的项会前移，如果当前索引 >= 被删除项的索引，保持当前索引不变即可（会自动显示下一条）
        // 如果当前索引 < 被删除项的索引，不需要调整
        // 如果列表为空，关闭对话框
        if (this.unconfirmedNotifyList.length === 0) {
          this.unconfirmedDialogVisible = false
        } else if (this.currentNotifyIndex >= this.unconfirmedNotifyList.length) {
          // 如果当前索引超出范围，调整为最后一个
          this.currentNotifyIndex = this.unconfirmedNotifyList.length - 1
        }
        // 否则保持当前索引不变，会自动显示下一条（因为后面的项前移了）
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width var(--sidebar-motion-ms, 200ms) var(--sidebar-motion-ease, cubic-bezier(0.4, 0, 0.2, 1));
}

.hideSidebar .fixed-header {
  width: calc(100% - #{$sideBarCollapsedWidth});
}

.mobile .fixed-header {
  width: 100%;
}
</style>
